import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface HeaderProps {
	className?: string;
	tab?: string;
}

const Header = (props: HeaderProps) => {
	const { className, tab } = props;
	const { t } = useTranslation();

	return (
		<div className={className}>
			<Grid alignItems='flex-end' container justifyContent='space-between' spacing={3}>
				<Grid item>
					<Typography component='h2' gutterBottom variant='overline'>
						{tab === 'characteristics' ? 'Characteristics' : 'Categories'}
					</Typography>
					<Typography component='h1' variant='h3'>
						{t('ui.label.settings')}
						{/* {t('ui.category.categories')} */}
					</Typography>
				</Grid>
			</Grid>
		</div>
	);
};

export default Header;
